import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-34a04ef6"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<img src=\"https://i.imgur.com/5cKDDpb.png\" width=\"150\" alt=\"logo\" data-v-34a04ef6><div class=\"spinner\" data-v-34a04ef6><div class=\"bounce1\" data-v-34a04ef6></div><div class=\"bounce2\" data-v-34a04ef6></div><div class=\"bounce3\" data-v-34a04ef6></div></div>", 2)
const _hoisted_3 = [
  _hoisted_1
]
const _hoisted_4 = {
  key: 1,
  class: "content"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.loading)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        style: _normalizeStyle({ height: '100%', width: _ctx.vw + 'px' }),
        class: "loading"
      }, _hoisted_3, 4))
    : (_openBlock(), _createElementBlock("div", _hoisted_4, [
        _renderSlot(_ctx.$slots, "default", {}, undefined, true)
      ]))
}